var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusPrimarySquare(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4.3H5C4.6134 4.3 4.3 4.6134 4.3 5V19C4.3 19.3866 4.6134 19.7 5 19.7H19C19.3866 19.7 19.7 19.3866 19.7 19V5C19.7 4.6134 19.3866 4.3 19 4.3ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z",
    fill: "#33A0AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 18C12.305 18 12.5615 17.7603 12.5615 17.4705V12.549H17.447C17.7435 12.549 18 12.2982 18 12.0028C18 11.7018 17.7435 11.4566 17.447 11.4566H12.5615V6.52949C12.5615 6.23967 12.305 6 12.0029 6C11.695 6 11.4442 6.23967 11.4442 6.52949V11.4566H6.55867C6.26223 11.4566 6 11.7018 6 12.0028C6 12.2982 6.26223 12.549 6.55867 12.549H11.4442V17.4705C11.4442 17.7603 11.695 18 12.0029 18Z",
    fill: "#33A0AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPrimarySquare);
export default __webpack_public_path__ + "static/media/plus-primary-square.c1177b6c377c249c8d8a9680508f786f.svg";
export { ForwardRef as ReactComponent };